import * as types from './types'
export const mutations = {
  [types.SET_NEED_WALLET](state, boolean) {
    state.needWallet = boolean
  },
  [types.COUPON_TYPE](state, payload) {
    state.couponId = payload.couponId
    state.couponText = payload.couponText
    state.couponType = payload.couponType
    state.couponDiscount = payload.couponDiscount || 0
  },
  [types.RESET_COUPON](state) {
    state.couponId = ''
    state.couponText = ''
    state.couponDiscount = 0
  },
  [types.INVOICE_TYPE](state, payload) {
    state.invoiceId = payload.invoiceId
    state.invoiceText = payload.invoiceText
    state.invoiceIsCompany = payload.invoiceIsCompany
    state.invoiceCode = payload.invoiceCode
    state.isAddInvoice = payload.isAddInvoice
  },
  [types.GAS_STATION](state, payload) {
    state.gaStation = payload.gaStation
    state.gaStationId = payload.gaStationId
  },
  [types.SET_LOGIN_SHOW](state, boolean) {
    state.loginShow = boolean
  },
  [types.SET_USER_MASGE](state, obj) {
    state.userMasge = obj
  },
  [types.PUST_MEG](state, payload) {
    state.oilGun = payload.oilGun
    state.amountOfRefueling = payload.amountOfRefueling
    state.selectOilOrderId = payload.selectOilOrderId
  }
}



// WEBPACK FOOTER //
// ./src/stores/pay/mutations.js